import AxiosClient from "../../../services/axios.services";

class ResponsiblesFactorsServices {
  getResponsibleFactor = (params) =>
    AxiosClient.get(
      "/api/app/carrera_sucesion_factores_responsables/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );

  getResponsibleFactorByID = (id) =>
    AxiosClient.get(
      `/api/app/carrera_sucesion_factores_responsables/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

  getFactorsCriteria = (params) =>
    AxiosClient.get(
      "/api/app/carrera_sucesion_factores_criterios/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );



  getOrganizationalUnits = (params) =>
    AxiosClient.get(
      "/api/app/carrera_sucesion_funcional_organizacion/",
      {
        headers: { "Content-Type": "application/json" },
        params: params,
      }
    );



  editResponsibleFactor = (id, data) =>
    AxiosClient.put(
      `/api/app/carrera_sucesion_factores_responsables/${id}/`,
      data,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
  saveResponsibleFactor = (data) =>
    AxiosClient.post(
      "/api/app/carrera_sucesion_factores_responsables/",
      data,
      {
        headers: { "Content-Type": "application/json" },

      },

    );
  deleteResponsibleFactor = (id) =>
    AxiosClient.delete(
      `/api/app/carrera_sucesion_factores_responsables/${id}/`,
      {
        headers: { "Content-Type": "application/json" },
      }
    );

}

export default new ResponsiblesFactorsServices();
